// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"4bb9cec6","349":"67929758","453":"ec9efe94","554":"e428f8f4","687":"6c1c3aa6","699":"95e7b010","709":"817b94d4","791":"0f897665","813":"6be64605","963":"cb5cc62b","989":"fc3bdeb4"}[chunkId] + ".chunk.js";
};